<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-btn
      color="primary"
      dark
      slot="activator"
      class="mb-2"
      :to="`/procurement/voucher_form`"
    >New</v-btn>

    <v-card-title>
      <h2>Transaction List</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.voucher_number }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.voucher_date) }}</td>
        <td class="text-xs-left">{{ props.item.currency_code }}</td>
        <td class="text-xs-left">{{ ((props.item.currency_code == 'BDT') ? props.item.bdt_db : props.item.usd_db) | currency}}</td>
        <td class="text-xs-left">{{ props.item.supplier_name }}</td>
        <td class="text-xs-left">{{ (props.item.is_post == 1) ? 'Yes' : 'No' }}</td>
        <td class="justify-center layout px-0">
          <v-btn
            icon
            class="mx-0"
            @click="editItem(props.index, props.item.id)"
            v-if="props.item.is_post != 1"
          >
            <v-icon color="teal">edit</v-icon>
            <!-- <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)" v-if="props.item.is_post == 1">
            <v-icon color="pink">delete</v-icon>-->
          </v-btn>
          <v-btn icon class="mx-0" v-if="props.item.is_post == 1">
            <v-icon color="teal">done</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="viewVoucher(props.item.id)">
            <v-icon color="teal">view_module</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import insertForm from "./voucherForm";
import Axios from "axios";
import ServerPath from '../../../server-path/server-path';

export default {
  components: {
    insertForm
  },

  data: () => ({
    valid: true,
    sm_id:'',

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},
    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Transaction Number",
        align: "left",
        sortable: true,
        value: "voucher_number"
      },
      { text: "Date", align: "left", sortable: true, value: "voucher_date" },
      {
        text: "Currency",
        align: "left",
        sortable: true,
        value: "currency_code"
      },
      { text: "Amount", align: "left", sortable: true, value: "amount" },
      { text: "Payee", align: "left", sortable: true, value: "supplier_name" },
      
      { text: "Posting Status", align: "left", sortable: true, value: "is_post" },

      { text: "Action", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: 0,
      type_name: "",
      short_name: ""
    }
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },
  mounted() {
    let sm_id = sessionStorage.getItem('sm_id');
  },

  created(){
    
    
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {
    viewVoucher(id){
      let sm_id = sessionStorage.getItem('sm_id');
      let onlyParam = {id:id,sm_id:sm_id,report_type:1,conName:2,funcName:'voucher_view'}
      let parameters = new URLSearchParams({ ...onlyParam}).toString();
      sessionStorage.setItem('report', JSON.stringify(onlyParam))
      let route = ServerPath.serverPath+'/pdf?'+parameters;
      window.open(route, '_blank');
    },

    getDataFromApi() {
      //let sm_id = sessionStorage.getItem('sm_id');
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
        (query_Data.descending = this.pagination.descending),
        (query_Data.page = this.pagination.page),
        (query_Data.rowsPerPage = this.pagination.rowsPerPage),
        (query_Data.search_val = this.search);
        (query_Data.sm_id = 'procurement') ;

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "voucher_master_ifo")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      //sessionStorage.setItem("voucher_info", item.id);
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.$store.commit("SET_VOUCHER_ENTRY_DATA", item);
      this.$router.push("/procurement/voucher_form");
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "voucher_master").then(res => {
        this.desserts.splice(row_index, 1);
        this.close(res);
        this.confirmModel = false;
      });
    },

    // confirmDelete(row_index, id) {
    //   commonService.deleteRow(id,"voucher_master").then(res => {
    //     if (res.status == 1) {
    //       this.desserts.splice(row_index, 1);
    //       this.getDataFromApi();
    //     } else {
    //       this.SnackbarVal.color = "error";
    //     }
    //     this.SnackbarVal.message = res.message;
    //     this.SnackbarVal.snackbar = true;

    //     this.confirmModel = false;
    //     this.dialog2 = false;
    //   });
    // },

    close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          $this.$set($this.desserts, $this.row_index, { ...res.data });
          $this.row_index = "";
        }
        this.SnackbarVal.color = "success";
      }
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/voucher/voucher_list.vue